module.exports = __webpack_public_path__ + "static/media/logo.2cd3810a.png";